export default "__VITE_ASSET__D7Do93_m__"